<template>
  <div class="card h-100 mb-0">
    <div class="card-body">
      <div
        class="d-flex flex-wrap justify-content-between align-items-center mb-3"
      >
        <h5 class="mb-2">{{ title }}</h5>
        <b-button
          v-if="viewAllTo"
          :to="viewAllTo"
          size="sm"
          variant="outline-info"
          class="mb-2 ml-auto"
          >{{ $t("label.dashboardViewAll") }}</b-button
        >
      </div>
      <div v-if="widget.loading" class="d-flex justify-content-center p-5">
        <b-spinner variant="info" />
      </div>
      <b-alert v-else-if="widget.error" show variant="danger">
        {{ $t("label.dashboardLoadError") }}
        <b-button size="sm" variant="outline-danger" @click="$emit('retry')">{{
          $t("label.retryPermissionDefinitions")
        }}</b-button>
      </b-alert>
      <template v-else>
        <slot />
        <div
          v-if="widget.total"
          class="d-flex flex-wrap justify-content-between align-items-center mt-3"
        >
          <small class="text-muted mb-2">{{
            $tc("label.results", widget.total, [widget.total])
          }}</small>
          <b-pagination
            :value="widget.page"
            :total-rows="widget.total"
            :per-page="widget.pageSize"
            class="mb-2"
            @change="$emit('page', $event)"
          />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: "DashboardUserListCard",
  props: {
    viewAllTo: { type: [String, Object], default: null },
    title: { type: String, required: true },
    widget: { type: Object, required: true },
  },
};
</script>
